import { Profile } from "types";

import { queryClient, supabase } from "../../services";

const queryProfiles = async (userId: string) => {
  const profiles = await supabase.from("profiles").select<string, Profile>().eq("user_id", userId);

  if (!profiles.data) {
    throw profiles.error;
  }

  return profiles.data;
};

export const GET_PROFILES = "profiles";

export const getProfiles = async (userId: string) => {
  return queryClient.fetchQuery({
    queryKey: [GET_PROFILES, userId],
    queryFn: () => queryProfiles(userId)
  });
};
